const contentData = [
    {
        type: 'COST EFFICIENCY',
        caption: '100% cost reduction from traditional content',
        contentPath: require('images/endless_possibilities/cost_efficiency.png'),
        videoContentPath: require('images/endless_possibilities/cost_efficiency.mp4'),
        contentFormat: 'video'
    },
    {
        type: 'IMAGES ON DEMAND',
        caption: '709 images created within 24 hours',
        contentPath: require('images/endless_possibilities/images_on_demand.png'),
        contentFormat: 'img'
    },
    {
        type: 'VIDEOS ON DEMAND',
        caption: '15 long-form videos created within 1 week',
        contentPath: require('images/endless_possibilities/videos_on_demand.png'),
        videoContentPath: require('images/endless_possibilities/videos_on_demand.mp4'),
        contentFormat: 'video'
    },
    {
        type: 'AUTHENTICITY',
        caption: 'UGC on product page increases conversion rate by 87%',
        contentPath: require('images/endless_possibilities/authenticity.png'),
        contentFormat: 'img'
    },
    {
        type: 'PERSONALIZATION',
        caption: '225 creators activated based on demographic criteria',
        contentPath: require('images/endless_possibilities/personalization.png'),
        contentFormat: 'img'
    },
    {
        type: 'QUALITY OF CONTENT',
        caption: 'Social Native content preferred over agency content',
        contentPath: require('images/endless_possibilities/quality_of_content.png'),
        contentFormat: 'img'
    },
    {
        type: 'HYPER-TARGETING',
        caption: 'Creators activated within a 3-mile radius of a NYC mural',
        contentPath: require('images/endless_possibilities/hyper_targeting.jpg'),
        contentFormat: 'img'
    },
    {
        type: 'AGE TARGETING',
        caption: 'Creators activated based on a minimum age requirement',
        contentPath: require('images/endless_possibilities/age_targeting.png'),
        contentFormat: 'img'
    },
    {
        type: 'GLOBALIZATION',
        caption: 'Creators activated across 18 countries',
        contentPath: require('images/endless_possibilities/globalization.png'),
        contentFormat: 'img'
    },
    {
        type: 'TESTIMONIALS',
        caption: 'Creators activated based on existing brand affinity',
        contentPath: require('images/endless_possibilities/testimonials.png'),
        videoContentPath: require('images/endless_possibilities/testimonials.mp4'),
        contentFormat: 'video'
    },
    {
        type: 'PRODUCT PLACEMENT',
        caption: 'Authentic content created for product launch',
        contentPath: require('images/endless_possibilities/product_placement.png'),
        contentFormat: 'img'
    },
    {
        type: 'BRAND AFFINITY',
        caption: 'Existing customers identified and activated',
        contentPath: require('images/endless_possibilities/brand_affinity.png'),
        contentFormat: 'img'
    }
];

export default contentData;



// WEBPACK FOOTER //
// ./web/js/components/endless_possibilities/endless_possibilities_info.js